function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6 1C3.24 1 1 3.24 1 6s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm-.5 2.5v1h1v-1h-1zm1 4.5c0 .275-.225.5-.5.5a.501.501 0 01-.5-.5V6c0-.275.225-.5.5-.5s.5.225.5.5v2zM2 6c0 2.205 1.795 4 4 4s4-1.795 4-4-1.795-4-4-4-4 1.795-4 4z",
  fill: "#F3F3F3"
});

function SvgInfoBuyin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 12 12",
    fill: "none"
  }, props), _ref);
}

export default SvgInfoBuyin;


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/info_buyin.svg
// module id = 1335
// module chunks = 10